import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VBuilderCategoryListComponent } from './v-builder-category-list/v-builder-category-list.component';
import { VBuilderCategoryDetailComponent } from './v-builder-category-detail/v-builder-category-detail.component';

const routes: Routes = [
  {
    path: '',
    component: VBuilderCategoryListComponent,
    data: { topNavigation: true, sideNavigation: false, selectedModule: 'VBuilderAdmin', title: 'VBuilder' }
  },
  {
    path: 'category/detail/:id',
    component: VBuilderCategoryDetailComponent,
    data: { topNavigation: true, sideNavigation: false, selectedModule: 'VBuilderAdmin', title: 'VBuilder' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VBuilderAdminRoutingModule { }
